import React from "react";
import ReactPaginate from 'react-paginate';

import "../../styles/Paginator.css";

const Paginator = ({pageCount, setCurrentPage, currentPage}) => {
  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
    if (window) window.scrollTo(0, 0)
  }

  return (
    <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        breakLabel={"..."}
        pageCount={pageCount}
        onPageChange={handlePageClick}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        containerClassName={"pagination"}
        activeClassName={"active"}
        forcePage={currentPage}
    />
  )
};

export default Paginator;